import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType, CustomerAccountType, DeviceState } from '@iotv/datamodel-core';
import { AppValueTypes, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { Avatar, Badge, Box, Button, CardHeader, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import Confirmation from '../../../Popup/Confirmation';
import NavLink from '../../../components/navigation/NavLink';
import { NavSections } from '../../../components/navigation/NavSections';
import AppDao from '../../../data/AppDao';
import { getCustomerHierarchy } from '../../../data/RoleQueries';
import { useSelectedObjects } from '../../../hooks/useSelectedObjects';
import { ComponentMode, ObjectViewType } from '../../../types/AppTypes';
import { ListerlizerAdapter } from '../../factories/Listerlizer/legacy/ListerlizerAdapter';
const getJoinedDevices = async (customer) => {
    const res = await AppDao.queryByGraph({
        contextObjects: [customer],
        path: [{ objectTypeId: 'Group', adjacencyType: AdjacentType.CHILD }],
    });
    if (res.err === null && res.data !== null) {
        const deviceGroups = res.data.getContainedItems().filter((device) => device.supportedType === 'Device');
        const wantedGroup = deviceGroups.filter((group) => group.name === 'All Devices');
        if (wantedGroup.length === 1) {
            return wantedGroup[0];
        }
        else {
            console.error('Invalid Group Count Found');
            console.error('Found', deviceGroups);
            console.error('Wanted', wantedGroup);
        }
    }
};
/** @deprecated - No longer used */
const DeviceAcceptanceCard = (props) => {
    const { contextCustomer, userFunctions, transactionFunctions } = props;
    const { state: [[selectedObjects, setSelectedObjects]], } = useSelectedObjects();
    const [sourceCustomer, setSourceCustomer] = useState();
    const [sourceGroup, setSourceGroup] = useState();
    const [confirmation, setConfirmation] = useState(false);
    const getDeviceListilizer = (context) => {
        const baseQueryFilter = [
            {
                filters: [{ key: 'state', value: DeviceState.JOINED, predicate: ComparisonType.EQUALS }],
                setOperation: LogicalOperatorType.AND,
            },
        ];
        return {
            initMode: ComponentMode.EDIT,
            transactionFunctions,
            userFunctions,
            adjacentFilter: {
                adjacentType: AdjacentType.CHILD,
                objectType: 'Device',
                filterConfig: baseQueryFilter,
            },
            autoQuery: true,
            columnVisibilityReferences: {
                dataTableReference: 'List',
                objectTypeId: 'ValidBusinessObject',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
            },
            viewDefinition: {
                name: {
                    key: 'name',
                    type: AppValueTypes.STRING,
                    label: 'Devices',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                state: {
                    key: 'state',
                    type: AppValueTypes.STRING,
                    label: 'State',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
            },
            viewObject: {
                matchedPrimary: context,
                matchedRelatedByPk: [],
                matchedRelatedBySk: [],
            },
            contextObject: context,
            searchRootObject: context,
            selectorConfigParams: {
                controls: {
                    add: false,
                    find: false,
                },
            },
            onSelectedUpdate: setSelectedObjects,
        };
    };
    useEffect(() => {
        const getCustomers = async (customer) => {
            const customerHier = await getCustomerHierarchy(customer);
            if (customerHier.err === null && customerHier.data !== null) {
                const topCustomer = customerHier.data.nodes.filter((customer) => customer.accountType === CustomerAccountType.V);
                if (topCustomer.length === 1) {
                    setSourceCustomer(topCustomer[0]);
                }
                else {
                    setSourceCustomer(undefined);
                    console.error('Top customer with ambiguity found');
                }
            }
            else {
                setSourceCustomer(undefined);
                console.error('Somehow, customer hierarchy did not get anything');
            }
        };
        if (contextCustomer) {
            getCustomers(contextCustomer);
        }
        else {
            setSourceCustomer(undefined);
        }
    }, [contextCustomer]);
    useEffect(() => {
        if (sourceCustomer) {
            getJoinedDevices(sourceCustomer).then((res) => {
                setSourceGroup(res);
            });
        }
    }, [sourceCustomer]);
    const moveConfirmation = useCallback(() => {
        setConfirmation(true);
    }, []);
    const moving = (list, context) => {
        const updated = list.map((obj) => {
            return { ...obj, state: DeviceState.INVENTORY };
        });
        const promiseList = updated.map((dev) => {
            return AppDao.save(dev);
        });
        Promise.all(promiseList).then((res) => {
            getJoinedDevices(context);
        });
    };
    return (_jsxs("div", { children: [_jsx(Box, { sx: {
                    m: 2,
                }, children: _jsx(Typography, { component: "h5", variant: "h5", children: "Device Acceptance" }) }), _jsx(CardHeader, { avatar: _jsx(NavLink, { filter: `${NavSections.DEVICE_ACCEPTANCE}`, children: _jsx(Badge, { color: "primary", children: _jsx(Avatar, { "aria-label": "recipe", children: sourceGroup ? (sourceGroup.name ? sourceGroup.name.substr(0, 1).toUpperCase() : `${sourceGroup.type} ?`) : '??' }) }) }), title: sourceGroup?.name }), _jsx(Button, { variant: "outlined", color: "primary", size: "small", disabled: selectedObjects.length === 0, onClick: moveConfirmation, children: "Import selected" }), sourceGroup && _jsx(ListerlizerAdapter, { ...getDeviceListilizer(sourceGroup) }), _jsx(Confirmation, { name: 'Move Devices',
                message: `Would you like to move ${selectedObjects.length} device(s) to Inventory?`,
                state: confirmation,
                changeState: setConfirmation,
                action: 'Move',
                actionFunction: () => sourceCustomer && moving(selectedObjects, sourceCustomer) })] }));
};
export default DeviceAcceptanceCard;
